<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-snackbar
        v-model="messageError.show"
        color="error"
        top
        :timeout="messageError.timeout"
        text-xs-center
      >
        {{ messageError.message }}
        <v-icon right dark>error_outline</v-icon>
      </v-snackbar>

      <v-flex xs12 offset-md1 md10>
        <v-card>
          <v-toolbar color="#b6d000" dark>
            <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

            <v-toolbar-title>
              <v-icon>assignment</v-icon>
              Okleveleim

              <!-- <div class="badge badge-danger text-white">BÉTA</div> -->
            </v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>

          <v-list v-for="(data, index) in datas" :key="index">
            <v-list-tile>
              <v-list-tile-avatar class="ml-3 mr-2">
                <v-progress-circular
                  :rotate="-90"
                  :size="100"
                  :width="10"
                  :value="data.diplomaPercent"
                  color="#2d4d85"
                >
                  {{ data.diplomaPercent }}%
                </v-progress-circular>
              </v-list-tile-avatar>

              <v-list-tile-content class="">
                <v-layout row wrap>
                  <v-flex xs10 md8>
                    <span class="diplomaTitle">
                      {{ data.course.title }}
                    </span>
                  </v-flex>
                  <v-flex xs2 md4>
                    <!-- <v-btn 
                                        color="info" 
                                        fab 
                                        small 
                                        right 
                                        class="mb-1" 
                                        style="right: 10px; top:0; position: absolute;"
                                        @click="downloadDiploma( data.course.id )"
                                        >
                                            <v-icon>cloud_download</v-icon>
                                        </v-btn> -->

                    <v-btn
                      v-if="data.diplomaPercent === 100"
                      color="info"
                      fab
                      small
                      right
                      class="mb-1"
                      style="right: 10px; top:0; position: absolute;"
                      @click="downloadDiploma(data.course.id)"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                    <v-btn
                      v-else
                      color="grey"
                      fab
                      small
                      right
                      class="mb-1"
                      style="right: 10px; top:0; position: absolute;"
                    >
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div></div>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  components: {
    Chart
  },
  data: () => ({
    user: "",
    datas: "",
    messageError: {
      show: false,
      message: "",
      timeout: 4500
    }
  }),
  methods: {
    getDiplomasData() {
      axios
        .post(this.$store.getters.getApiUrl + "/api/diploma", {
          token: this.$store.getters.getToken
        })
        .then(response => {
          // console.log('diploma - resp: ', response.data);
          this.$data.datas = response.data.diplomasData;
          this.$data.user = response.data.user;
        })
        .catch(error => {
          if (error.length > 0) {
            // console.log('profile- error: ', error);
          }
        });
    },
    downloadDiploma(courseId) {
      window.open(
        this.$store.getters.getApiUrl +
          "/api/diploma/download/" +
          this.$data.user.id +
          "/" +
          courseId,
        "_blank"
      );
    }
  },
  created: function() {
    this.getDiplomasData();
  }
};
</script>
